import React, { useEffect } from 'react'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'
import { isValidURL } from 'modules/core/lib/url'

import { Element } from 'modules/forms/lib/Element'
import { Answer } from 'modules/forms/lib/types'

interface UrlElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
  disabled?: boolean
}

/**
 * Editor component for UrlElement
 */
const UrlElementQuestion: React.FC<UrlElementQuestionProps> = ({ element, onChange, disabled }) => {
  const [value, setValue] = React.useState<string | undefined>(element.answer?.answer)
  const [touched, setTouched] = React.useState(false)

  useEffect(() => {
    setValue(element.answer?.answer)
  }, [element.id, element.answer?.answer])

  const handleOnChange = (newValue: string): void => {
    setValue(newValue)
    onChange?.({ answer: newValue })
  }

  const handleOnBlur = (): void => {
    setTouched(true)
  }

  const getError = (): string | undefined => {
    if (!touched) {
      return undefined
    }
    if (!value && element.mandatory) {
      return i18n.t('forms.render.answer_required')
    }
    if (value && !isValidURL(value)) {
      return i18n.t('forms.render.invalid_url')
    }
  }

  return (
    <TextField
      hideLabel
      label={element.label}
      mandatory={element.mandatory}
      placeholder={i18n.t('forms.render.url_placeholder')}
      value={value}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      readonly={disabled}
      error={getError()}
      type="text"
    />
  )
}

export default UrlElementQuestion
